<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap align-content-start>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-layout column wrap xs6>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
            </v-flex>
            <v-flex xs6 v-if="!newStdRiskTxt">
              <v-subheader class="queryLabel">{{labels.riskNo}}</v-subheader>
              <div class="title">{{this.stdRiskTxtForm.riskNo}}</div>
            </v-flex>
            <v-flex xs6 v-else>
              <v-autocomplete :label="labels.riskNo" v-model="stdRiskTxtForm.riskNo" :items="riskList" :error-messages="errors.first('scheme') ? errors.first('scheme') : errors.collect('riskNo')" data-vv-name="riskNo" :data-vv-as="labels.riskNo" v-validate="'required'" :loading="riskLoading"></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-if="!newStdRiskTxt">
              <v-subheader class="queryLabel">{{labels.stdRiskTxt}}</v-subheader>
              <div class="title">{{this.stdRiskTxtForm.stdRiskTxt}}</div>
            </v-flex>
            <v-flex xs6 v-else>
              <v-autocomplete :label="labels.stdRiskTxt" v-model="stdRiskTxtForm.stdRiskTxt" :items="stdTxtList" item-text="value" item-value="value" :error-messages="errors.collect('stdRiskTxt')" data-vv-name="stdRiskTxt" :data-vv-as="labels.stdRiskTxt" v-validate="'required'" :loading="textLoading" @input="doQueryText"></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout column wrap xs6>
            <v-flex xs6>
              <v-textarea box outline rows="10" :label="labels.previewTxt" v-model="previewText" readonly no-resize></v-textarea>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave" v-if="newStdRiskTxt">
        Save Risk Text
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-flex>
    <!-- <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
        {{ newStdRiskTxt ? 'Save Risk Text' : 'Update Risk Text' }}
        <v-icon right>{{newStdRiskTxt ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex> -->
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { STDRISKTEXT_SET } from '@/store/types'
export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme',
        riskNo: 'Risk No*',
        stdRiskTxt: 'Standard Risk Text*',
        previewTxt: 'Preview Text'
      },
      stdRiskTxtForm: {
        scheme: null,
        riskNo: null,
        stdRiskTxt: null
      },
      newStdRiskTxt: false,
      riskList: [],
      stdTxtList: [],
      riskLoading: false,
      textLoading: false,
      previewText: '',
      submitting: false
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  watch: {
    'ids.riskNo': function (value) {
      this.resetMessages()
      this.resetValidator()
      this.doClearForm()
      this.stdRiskTxtForm.scheme = this.ids.scheme
      Promise.all([this.doRiskList(), this.doStdRiskTxtList()])
      if (value !== 'new') {
        this.newStdRiskTxt = false
        if (value !== null) {
          this.fetchData(value)
        }
      } else {
        this.newStdRiskTxt = true
      }
    }
  },
  methods: {
    async fetchData(riskNo) {
      const apiURI = this.schemeMenu.menu.pkgStdRiskTxtGet
      if (apiURI) {
        const expand = {
          scheme: this.ids.scheme,
          riskNo: this.ids.riskNo
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.stdRiskTxtForm.scheme = data.pkgStdRiskTxt.scheme
            this.stdRiskTxtForm.riskNo = data.pkgStdRiskTxt.riskNo
            this.stdRiskTxtForm.stdRiskTxt = data.pkgStdRiskTxt.stdRiskTxt
            this.previewText = data.pkgStdRiskTxt.stdRiskTxtDesc
            this.menu = extractMenu(result.data._links)
            this.$store.commit(STDRISKTEXT_SET, data.pkgStdRiskTxt.stdRiskTxt)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Standard Risk Text Review')
      }
    },
    async doRiskList() {
      const apiURI = this.schemeMenu.menu.riskList
      if (apiURI) {
        try {
          const expand = {
            scheme: this.ids.scheme
          }
          this.riskLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.riskList = data.riskList
          }
          this.riskLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Risk List')
      }
    },
    async doStdRiskTxtList() {
      const apiURI = this.schemeMenu.menu.stdTxtList
      if (apiURI) {
        try {
          this.textLoading = true
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.stdTxtList = data.stdRiskTxt
          }
          this.textLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Text List')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.stdRiskTxtForm.scheme = this.ids.scheme
      this.stdRiskTxtForm.riskNo = null
      this.stdRiskTxtForm.stdRiskTxt = null
      this.previewText = ''
    },
    async doQueryText(value) {
      const tempText = this.stdTxtList.find(item => item.value === value)
      this.previewText = tempText.label
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newStdRiskTxt) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      try {
        const apiURI = this.schemeMenu.menu.pkgStdRiskTxtCreate
        if (apiURI) {
          const formatForm = {
            scheme: this.stdRiskTxtForm.scheme,
            riskNo: this.stdRiskTxtForm.riskNo,
            stdRiskTxt: this.stdRiskTxtForm.stdRiskTxt
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab')
          }
        }
      } catch (error) {
        const { data } = error.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.pkgStdRiskTxtUpdate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.stdRiskTxtForm.scheme,
            riskNo: this.stdRiskTxtForm.riskNo,
            stdRiskTxt: this.stdRiskTxtForm.stdRiskTxt
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$store.commit(STDRISKTEXT_SET, this.stdRiskTxtForm.stdRiskTxt)
            this.fetchData(this.ids.riskNo)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  props: {
    ids: {
      type: Object,
      default () {
        return {
          scheme: null,
          riskNo: null,
          itemNo: null
        }
      }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
